export function buildLoginRedirectUrl(appBaseUrl: string, currentPath: string): string {
  return `${appBaseUrl}/authenticate/login?next=${encodeURIComponent(currentPath)}`;
}
